export const getListeners = state => state.statusChecker.listeners;
export const isFetchPending = state => state.statusChecker.isPending;
